import { render, staticRenderFns } from "./domainList.vue?vue&type=template&id=46a6cc22&scoped=true&"
import script from "./domainList.vue?vue&type=script&lang=js&"
export * from "./domainList.vue?vue&type=script&lang=js&"
import style0 from "./domainList.vue?vue&type=style&index=0&id=46a6cc22&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6cc22",
  null
  
)

export default component.exports